module.exports = __webpack_public_path__ + "static/media/smart_display.41e861ce.svg";